<template>
  <div style="background: linear-gradient(to bottom,#1f1c1f 0,#1f1c1f 100%);">
    <div>
      <van-nav-bar :title="$t('影院.影院')" class="header_b">

      </van-nav-bar>
    </div>
    <div class="video_box">
      <!--div class="nav_box_w">
        <div class="n_item" :class="navSel == kindex ?'active':''" v-for="(item,kindex) in videolitem" :key="item.id"  @click="onChange(item.id);navSel = kindex">
          {{ item.name }}
        </div>
      </div-->
      <div class="nav_box_w">
        <div class="n_item" :class="navSel2 == kindex ?'active':''" v-for="(item,kindex) in nav2list" :key="kindex"  @click="navSel2 = kindex">
          {{ item }}
        </div>
      </div>
      <div class="" style="height: 10px;"></div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <div class="list-item">
            <div class="movie-list-item" v-for="(i, key) in data" :key="key" @click="toPlayVideo(i.id)">
              <div class="imb_box">
                <img :src="i.vod_pic" class="van_img" />
                <div class="cc_zan">{{ $t('影院.播放') }}{{ i.count
                    }}</div>
              </div>
              <div class="c_yy">{{ i.vod_name }}</div>
            </div>

          </div>

        </van-list>
      </van-pull-refresh>
    </div>
    <div style="height: 55px;"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      navSel:0,
      navSel2:0,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      videolitem: [],
      data: [],
      page: 0,
      id: 888,
    };
  },
  computed: {
    nav2list() {
      return [this.$t('影院.全部'), this.$t('影院.最高分')];
    },
  },
  methods: {
    onLoad(isRefresh = false) {
      if (isRefresh) {
        this.page = 0;
        this.data = [];
      }

      this.loading = true;

      this.getVideoList().then(() => {
        this.loading = false;
        if (this.refreshing) {
          this.refreshing = false;
          Toast(this.$t('请求.刷新成功'));
        }
      });
    },
    onChange(name) {
      this.id = name;
      this.finished = false;
      this.loading = true;
      this.page = 0;
      this.data = [];
      this.onLoad(true);

    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.loading = true;
      this.onLoad(true);
    },
    toPlayVideo(id) {
      this.$router.push({ path: "/PlayVideo", query: { id } });
    },
    getVideoList() {
      return new Promise((resolve, reject) => {
        this.$http({
          method: "get",
          data: { id: this.id, page: this.page },
          url: "video_list",
        }).then((res) => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            
            // ✅ 去重：过滤掉已经存在于 this.data 中的 id
            const existingIds = new Set(this.data.map(item => item.id))
            const newItems = res.data.data.filter(item => !existingIds.has(item.id))
            
            if (newItems.length > 0) {
              this.data = this.data.concat(newItems)
              this.page++
            } else {
              this.finished = true  // 全是重复数据，说明已加载完
            }
            resolve()
          } else {
            this.finished = true
            resolve()
          }
        }).catch((error) => {
          console.error("Error fetching video list:", error)
          reject(error)
        })
      })
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getVideoClass() {
      this.$http({
        method: "get",
        url: "video_class",
      }).then((res) => {
        const lanng = 'zh';
        this.videolitem = res.data;
        const obj = { id: 888, name: "最新,new,最新の,new" };
        this.videolitem.unshift(obj);
        this.videolitem.forEach((item) => {
          const parts = item.name.split(",");
          lanng == 'kr' ? item.name = parts[0] : lanng == 'en' ? item.name = parts[1] : lanng == 'ja' ? item.name = parts[2] : item.name = parts[3]

        });


      });
    },
  },
  created() {
    this.getVideoClass();

  },
};
</script>

<style scoped lang="less">
.van-nav-bar {
  background: linear-gradient(to bottom, #1f1c1f 0, #1f1c1f 100%);
}
.header_b{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.video_box{
  padding-top: 100px;
  /deep/ .van-tabs__nav{
    background: linear-gradient(120deg,#212121,#313131);
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
  }
  .nav_box_w{
    display: flex;
    background: linear-gradient(120deg,#212121,#313131);
    padding: 20px;
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
    flex-wrap: wrap;
    .n_item{
      color: #fff;
      padding: 2px 16px;
      border-radius: 40px;
      margin-right: 20px;
      &.active{
        background:linear-gradient(90deg,#efcba7,#dcab76) ;
        color: #623a13;
        
      }
    }
  }
  .c_yy{
    width: 100%;
    overflow: hidden; /* 确保超出容器的内容被裁剪 */
    white-space: nowrap; /* 确保文本在一行内显示 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    color: #c7c7c7;
    font-size: 30px;
    padding: 12px 0 30px;
  }
  .movie-list-item{
    .imb_box{
      position: relative;
      .van_img{
        height: 300px;
        width: 100%;
        border-radius: 20px;
      }
      .cc_zan{
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 20px 0;
        color: #fff;
        bottom: 26px;
        right: 26px;
        font-size: 24px;
        padding: 2px 16px;
      }
    }
  }
}
/deep/ .van-tabs__wrap {
  height: 13vw;
  padding-bottom: 10px;
}

/deep/ .van-tabs__line {
  background-color: #c571cf;
}

/deep/ .van-loading__text {
  font-size: 32px;
  color: #000;

}

/deep/ .van-list__finished-text {
  font-size: 32px;
  color: #000;

}

/deep/ .van-pull-refresh__head {
  height: 100px;
}

/deep/ .van-pull-refresh__text {
  font-size: 32px;
  /* 设置字体大小 */
  color: #000;

}

.list-item {
  display: flex;
  width: calc(100% - 7vw);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}

.movie-list-item {
  width: calc(50% - 12px);

}

.cover_img {
  border-radius: 20px;
}

.movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 6vw;
}

.movie-time-div {
  background-color: rgba(0, 0, 0, 0.4);
  height: 8vw;
  color: #fff;
  border-radius: 0 0 40px 40px;
}

.movie-list-item-bottom div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 24vw;
  padding-left: 16px;
  font-size: 3vw;
}

.activeBg {
  color: rgb(197, 113, 207);
  font-weight: bold;
  background: url('/img/common/badge-new.png') right top 5px / 30% no-repeat;
}
</style>
